import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AudioService {
  public audioSource: any[] = [];

  public currentAudio: string = '';
  public isPlay: boolean = false;

  private currentAudioSubject = new BehaviorSubject<string>(this.currentAudio);
  currentAudio$ = this.currentAudioSubject.asObservable();

  private playAudioSubject = new BehaviorSubject<boolean>(this.isPlay);
  playAudio$ = this.playAudioSubject.asObservable();

  setCurrentAudio(audioUrl: string): void {
    this.currentAudio = audioUrl;
    this.currentAudioSubject.next(audioUrl);
  }

  setIsPlay(isPlay: boolean): void {
    this.isPlay = isPlay;
    this.playAudioSubject.next(isPlay);
  }

  constructor() {
  }
}
